<template>
  <v-card class="mt-3 filter-report" flat>
    <v-card-actions class="mb-3 pa-0">
      <v-btn color="primary" :disabled="!items.length" @click="csvExport">
        <v-icon left>cloud_download</v-icon>
        Export report to csv
      </v-btn>
      <v-spacer />
    </v-card-actions>
    <template v-if="items.length">
      <v-card v-for="(item, index) in items" :key="`imp-rep-${index + 1}`">
        <v-card-title class="primary question-report-title">
          <span v-html="questionTitle(item.order, item.question)"></span>
        </v-card-title>
        <v-row row wrap class="mx-3 question-table-header hidden-xs-only">
          <v-col
            v-for="data in item.answers"
            :key="data"
            sm="2"
            cols="12"
            class="px-0 pt-5"
          >
            {{ data.text }}
          </v-col>
          <v-col sm="2" cols="12" class="px-0 pt-5">Total Response</v-col>
        </v-row>
        <v-row row wrap class="mb-3 mx-3 question-table-body">
          <v-col
            v-for="data in item.answers"
            :key="data"
            sm="2"
            cols="12"
            class="px-0 py-3"
          >
            <span class="hidden-sm-and-up">{{ data.text }}<br /></span>
            {{ `${data.count}  (${data.percentage}%)` }}
          </v-col>
          <v-col sm="2" cols="12" class="px-0 py-3">
            <span class="hidden-sm-and-up">Total Response<br /></span>
            {{ item.totalAnswers }}
          </v-col>
        </v-row>
      </v-card>
    </template>
    <!-- <v-data-table
      :headers="headers"
      :items="items"
      :options.sync="pagination"
      :items-per-page="rowsPerPageItems"
      :loading="loading"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="item in items" :key="item.name">
            <td
              v-for="header in headers"
              :class="[
                header.align && header.align === 'center'
                  ? 'text-center'
                  : 'text-left'
              ]"
              :key="item.id + '-' + header.value"
            >
              {{ item[header.value] }}
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table> -->
    <!-- <div class="text-center">
      <v-pagination
        v-model="pagination.page"
        :length="pageCount"
      ></v-pagination>
    </div> -->
  </v-card>
</template>

<script>
export default {
  props: ['headers', 'items', 'loading'],
  data() {
    return {
      selected: [],
      rowsPerPageItems: 15,
      pagination: {
        rowsPerPageItems: 15
      },
      pageCount: 0
    }
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    }
  },
  methods: {
    questionTitle(order, question) {
      return `Slide ${order}: ${question}`
    },
    csvExport() {
      this.$emit('csvExport')
    }
  }
}
</script>

<style lang="scss">
.filter-report {
  width: 100%;

  .v-datatable__actions__range-controls {
    display: none !important;
  }

  h2 {
    display: block;
    width: 100%;
  }

  p {
    padding: 0;
    margin: 0;
  }
}

.question-report-title {
  color: white;
}
.question-table-header {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.75rem;
  font-weight: bold;
  text-align: center;
}
.question-table-body {
  color: rgba(0, 0, 0, 0.87);
  font-size: 0.875rem;
  text-align: center;

  span {
    color: rgba(0, 0, 0, 0.6);
    font-size: 0.75rem;
    font-weight: bold;
    text-align: center;
  }
}
</style>
